import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  DialogActions,
  CustomTextField,
} from '../../../common/components';

const ScoreCoefficientDialog = ({ open, onClose, onSave, selectedItem, editMode }) => {
  const [formData, setFormData] = useState({
    value: '',
    start_date: '',
    due_date: '',
  });

  const [errors, setErrors] = useState({});
  const [saveAttempted, setSaveAttempted] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData({
        value: selectedItem?.value !== undefined ? selectedItem.value.toString() : '',
        start_date: selectedItem?.start_date ? selectedItem.start_date.slice(0, 10) : '',
        due_date: selectedItem?.due_date ? selectedItem.due_date.slice(0, 10) : '',
      });
      setErrors({});
      setSaveAttempted(false);
    }
  }, [open, selectedItem]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const isValidDecimal = (value) => {
    const number = parseFloat(value);
    return !isNaN(number) && number > 0 && number < 1;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.value) {
      newErrors.value = 'required';
    } else if (!isValidDecimal(formData.value)) {
      newErrors.value = 'decimal';
    }

    if (!formData.start_date || !formData.due_date) {
      newErrors.dates = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    setSaveAttempted(true);

    if (validateForm()) {
      onSave(formData);
    }
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>
        {editMode
          ? `Editar Coeficiente de puntaje: "${formData.value}"`
          : 'Agregar Coeficiente de puntaje'}
      </DialogTitle>

      <DialogBody sx={{ display: 'block' }}>
        <Box>
          <Box sx={{ display: 'block' }}>
            <CustomTextField
              margin="dense"
              name="value"
              label="Valor"
              type="number"
              fullWidth
              inputProps={{
                step: '0.001',
                min: '0',
                max: '9.9999999',
              }}
              value={formData.value}
              onChange={handleInputChange}
              error={errors.value || (saveAttempted && !formData.value)}
              helperText={
                errors.value === 'required' || (saveAttempted && !formData.value)
                  ? 'Debes ingresar un valor.'
                  : errors.value === 'decimal'
                  ? 'El valor debe ser un decimal entre 0 y 1 (excluyendo 0 y 1).'
                  : ''
              }
            />

            <CustomTextField
              margin="dense"
              name="start_date"
              label="Fecha Inicio"
              type="date"
              shrinkLabel
              fullWidth
              value={formData.start_date}
              onChange={handleInputChange}
              error={
                errors.dates || (saveAttempted && (!formData.start_date || !formData.due_date))
              }
            />

            <CustomTextField
              margin="dense"
              name="due_date"
              label="Fecha Fin"
              type="date"
              shrinkLabel
              fullWidth
              value={formData.due_date}
              onChange={handleInputChange}
              error={
                errors.dates || (saveAttempted && (!formData.start_date || !formData.due_date))
              }
              helperText={
                errors.dates || (saveAttempted && (!formData.start_date || !formData.due_date))
                  ? 'Debes ingresar las fechas de inicio y fin.'
                  : ''
              }
            />
          </Box>
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={handleSave} />
    </DialogContainer>
  );
};

export default ScoreCoefficientDialog;
